<div>
  <div >
    <div>
      <span class="reviewcontent">
        <!-- Are you sure you want to mark {{ resourceTypeLabel }} for review? -->
         Once you mark the application for review, it will be moved to the In Review queue. Are you sure you want to mark the application for review? 
      </span>
    </div>

    <div *ngIf="resourceType === 'SERVICEPROVIDER'" style="margin-top: 32px;">
      <span class="selectSA">
        Please select your nearest Technical Advisor for review:
      </span>
      <div class="advisor-dropdown mt-3">
        <p-dropdown [options]="advisorList" [(ngModel)]="selectedAdvisor" optionLabel="name"
          placeholder="Select an Advisor" [disabled]="isReviewing">
        </p-dropdown>
      </div>
    </div>

    <div style="margin-top: 35px;">
      <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center m-2">
          <!-- <button pButton class="btn-1 btn-warning-1  " (click)="onCancel()"
            [disabled]="isReviewing">Cancel</button> -->
            <button class="btn btn-cancel btn-warning-1" pButton
            (click)="onCancel()">Cancel</button>
        </div>
        <div class="flex align-items-center justify-content-center m-2">
          <button pButton class=" btn-warning-2 outlined-1 small raised btn-primary" (click)="onReview()">Mark for Review</button>
        </div>
      </div>
    </div>
  </div>
</div>